import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable/index";
import useApi from "../../core/customhook/useApi";
import FeatherIcon from "feather-icons-react";
import Swal from "sweetalert2";

const Goals = () => {
  const [empname, setEmpname] = useState("");
  const [empnameID, setEmpnameID] = useState("");
  const [karaCallAuto, setKraCallAuto] = useState(true);
  const [count, setCount] = useState(1);
  const [activeTab, setActiveTab] = useState("KRA");
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState<any[]>([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const fyStart = month >= 3 ? year : year - 1;
    return formatFinancialYear(fyStart);
  };
  const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());

  const [newItem, setNewItem] = useState<any>({
    employee_id: "",
    category_id: "",
    is_eligible_promotion: "No",
  });

  const kracolumns = [
    {
      title: "SrNo.",
      dataIndex: "SrNo",
      render: (text: string, record: any, index: number) => (
        <h6 className="fw-medium fs-14 text-dark">{index + 1}</h6>
      ),
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      sorter: (a: any, b: any) =>
        a.employee_name.localeCompare(b.employee_name),
    },
    {
      title: "Category Name",
      dataIndex: "category_name",
      sorter: (a: any, b: any) =>
        a.category_name.localeCompare(b.category_name),
    },
    {
      title: "Smart Goals",
      dataIndex: "smart_goals",
      sorter: (a: any, b: any) => a.smart_goals.localeCompare(b.smart_goals),
    },
    {
      title: "Target",
      dataIndex: "target",
      sorter: (a: any, b: any) => a.target.localeCompare(b.target),
    },
    {
      title: "Accivement Date",
      dataIndex: "target_achievement_date",
      sorter: (a: any, b: any) =>
        a.target_achievement_date.localeCompare(b.target_achievement_date),
    },
    {
      title: "Weightage",
      dataIndex: "weightage",
      render: (text: string) => <span>{text}%</span>,
      sorter: (a: any, b: any) => a.weightage - b.weightage,
    },

    // {
    //   title: "Action",
    //   dataIndex: "actions",
    //   render: (_: any, record: any) => (
    //     <div className="action-icon d-inline-flex">
    //       <Link
    //         to="#"
    //         className="me-2"
    //         data-bs-toggle="modal"
    //         data-bs-target="#edit_behavCom"
    //         onClick={() => {
    //           setSelectedItem(record);
    //         }}
    //       >
    //         <i className="ti ti-edit" />
    //       </Link>
    //       <Link
    //         to="#"
    //         className="me-2"
    //         data-bs-toggle="modal"
    //         data-bs-target="#delete_modal"
    //         onClick={() => {
    //           setSelectedItem(record);
    //         }}
    //       >
    //         <i className="ti ti-trash" />
    //       </Link>
    //     </div>
    //   ),
    // },
  ];
  const bracolumns = [
    {
      title: "SrNo.",
      dataIndex: "SrNo",
      render: (text: string, record: any, index: number) => (
        <h6 className="fw-medium fs-14 text-dark">{index + 1}</h6>
      ),
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      sorter: (a: any, b: any) =>
        a.employee_name.localeCompare(b.employee_name),
    },
    {
      title: "Category Name",
      dataIndex: "category_name",
      sorter: (a: any, b: any) =>
        a.category_name.localeCompare(b.category_name),
    },
    {
      title: "Competency",
      dataIndex: "competency",
      sorter: (a: any, b: any) => a.competency.localeCompare(b.competency),
    },
    {
      title: "Description",
      dataIndex: "description",
      sorter: (a: any, b: any) => a.description.localeCompare(b.description),
    },
    {
      title: "Weightage",
      dataIndex: "weightage",
      render: (text: string) => <span>{text}%</span>,
      sorter: (a: any, b: any) => a.weightage - b.weightage,
    },

    // {
    //   title: "Action",
    //   dataIndex: "actions",
    //   render: (_: any, record: any) => (
    //     <div className="action-icon d-inline-flex">
    //       <Link
    //         to="#"
    //         className="me-2"
    //         data-bs-toggle="modal"
    //         data-bs-target="#edit_behavCom"
    //         onClick={() => {
    //           setSelectedItem(record);
    //         }}
    //       >
    //         <i className="ti ti-edit" />
    //       </Link>
    //       <Link
    //         to="#"
    //         className="me-2"
    //         data-bs-toggle="modal"
    //         data-bs-target="#delete_modal"
    //         onClick={() => {
    //           setSelectedItem(record);
    //         }}
    //       >
    //         <i className="ti ti-trash" />
    //       </Link>
    //     </div>
    //   ),
    // },
  ];

  const employeeColumns = [
    {
      title: "EmpCode",
      dataIndex: "employee_id",
      render: (text: string, record: any) => (
        <Link
          to="#"
          onClick={() => {
            setEmpname(record.employee_name);
            setModalOpen(false);
          }}
          style={{ textDecoration: "underline", cursor: "pointer" }}
          data-bs-dismiss="modal"
        >
          {text}
        </Link>
      ),
      sorter: (a: any, b: any) => a.employee_id.localeCompare(b.employee_id),
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      render: (text: string, record: any) => (
        <Link
          to="#"
          onClick={() => {
            setEmpname(record.employee_name);
            setEmpnameID(record.employee_id);
            setModalOpen(false);
          }}
          style={{ textDecoration: "underline", cursor: "pointer" }}
          data-bs-dismiss="modal"
        >
          {text}
        </Link>
      ),
      sorter: (a: any, b: any) =>
        a.employee_name.localeCompare(b.employee_name),
    },
    {
      title: "Designation",
      dataIndex: "designation", // Change From to designation
      sorter: (a: any, b: any) => a.designation.localeCompare(b.designation),
    },
    {
      title: "Department",
      dataIndex: "department", // Change To to department
      sorter: (a: any, b: any) => a.department.localeCompare(b.department),
    },
    {
      title: "Locatation",
      dataIndex: "branch_name", // Change To to branch_name
      sorter: (a: any, b: any) => a.branch_name.localeCompare(b.branch_name),
    },
  ];

  const {
    data: getcategoryResponse,
    loading: getCategoryLoading,
    error: getCategoryError,
  } = useApi("/api/manager/view-category", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [count],
  });

  const {
    data: teamData,
    loading: teamLoading,
    error: teamError,
  } = useApi("/api/manager/team-member", {
    method: "GET",
    autoCall: true,
  });
  const data = teamData?.data;

  const getInputdata = (e: any) => {
    const { name, type, value, checked } = e.target;
    setNewItem({
      ...newItem,
      [name]: type === "checkbox" ? (checked ? "Yes" : "No") : value,
    });
  };

  const {
    data: getKRAGoalsResponse,
    loading: getKRAGoalsLoading,
    error: getKRAGoalsError,
    callApi: getemployeeKraData,
  } = useApi("/api/manager/view-kra-employee-goals", {
    method: "POST",
    payload: {
      financial_year: finance_year,
      employee_id: "",
    },
    autoCall: karaCallAuto,
    dependencies: [count],
  });

  const {
    data: getbehaviouralGoalsResponse,
    loading: getbehaviouralGoalsLoading,
    error: getbehaviouralGoalsError,
    callApi: getemployeebehaviouralData,
  } = useApi("/api/manager/view-behavioural-employee-goals", {
    method: "POST",
    payload: {
      financial_year: finance_year,
      employee_id: "",
    },
    autoCall: false,
    dependencies: [count],
  });

  const getKRAGoals = async () => {
    const payload = {
      financial_year: finance_year,
      employee_id: empnameID,
    };
    try {
      const response = await getemployeeKraData(payload);
      if (response.success) {
        setCount(count + 1);
      }
    } catch (error: any) {
      console.error("Error while adding :", error);
      Swal.fire({
        title: "Error!",
        text: error.response.data.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const getBehaviouralGoals = async () => {
    const payload = {
      financial_year: finance_year,
      employee_id: empnameID,
    };
    try {
      const response = await getemployeebehaviouralData(payload);
      if (response.success) {
        setCount(count + 1);
      }
    } catch (error: any) {
      console.error("Error while adding :", error);
      Swal.fire({
        title: "Error!",
        text: error.response.data.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  console.log("getKRAGoalsResponse", getKRAGoalsResponse);
  console.log("getbehaviouralGoalsResponse", getbehaviouralGoalsResponse);

  const {
    data: addGoalsResponse,
    loading: addGoalsLoading,
    error: addGoalsError,
    callApi: addGoals,
  } = useApi("/api/manager/assign-category-employee", {
    method: "POST",
    autoCall: false,
    dependencies: [count],
  });

  const AddNewItem = async (e: any) => {
    e.preventDefault();
    try {
      const response = await addGoals(newItem);
      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
        document.getElementById("close_modal")?.click();
        setCount(count + 1);
        setNewItem({
          category_id: "",
          employee_id: "",
          is_eligible_promotion: "",
        });
      }
    } catch (error: any) {
      console.error("Error while adding :", error);
      Swal.fire({
        title: "Error!",
        text: error.response.data.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const UpdateItemData = async (e: any) => {
    e.preventDefault();
    try {
    } catch (error) {
      console.error("Error while updating :", error);
    }
  };

  const DeleteItem = async () => {
    try {
    } catch (error) {
      console.error("Error while deleting :", error);
    }
  };
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Goals </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item">Goal Settings</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Goals
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
              <div className="input-icon w-120 position-relative mb-2">
                <select
                  value={finance_year}
                  onChange={(e) => setFinance_year(e.target.value)}
                  className="form-select"
                >
                  {(() => {
                    const today = new Date();
                    const currentYear =
                      today.getMonth() >= 3
                        ? today.getFullYear()
                        : today.getFullYear() - 1;

                    return Array.from({ length: 1 }, (_, i) => {
                      const year = currentYear - i;
                      const nextYearShort = String(year + 1).slice(-2);
                      const financialYear = `${year}-${nextYearShort}`;

                      return (
                        <option key={financialYear} value={financialYear}>
                          {financialYear}
                        </option>
                      );
                    });
                  })()}
                </select>
              </div>
              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#add_category"
                  className="btn btn-primary custom_button d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Assign Goals
                </Link>
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card p-3">
            {/* <div
              className="mb-1"
              style={{ maxWidth: "500px", position: "relative" }}
            >
              <input
                type="text"
                name="empname"
                id="employeeSearch"
                className="form-control"
                placeholder="Type name / code"
                value={empname}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const value = e.target.value;
                  setEmpname(value);
                  setEmpnameID(value);
                  if (value.trim()) {
                    const matches = data.filter((item: any) =>
                      item.employee_name
                        .toLowerCase()
                        .includes(value.toLowerCase())
                    );
                    setFilteredSuggestions(matches);
                    setShowSuggestions(true);
                  } else {
                    setFilteredSuggestions([]);
                    setShowSuggestions(false);
                  }
                }}
              />

              <button
                type="button"
                className="btn btn-primary btn-sm"
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "8px",
                  transform: "translateY(-50%)",
                  padding: "4px 8px",
                }}
                onClick={() => setModalOpen(true)}
                data-bs-toggle="modal"
                data-bs-target="#employee_data_modal"
              >
                <FeatherIcon icon="more-horizontal" size="16" />
              </button>

              {showSuggestions && filteredSuggestions.length > 0 && (
                <ul
                  className="dropdown-menu show"
                  style={{
                    width: "100%",
                    maxHeight: "200px",
                    overflowY: "auto",
                    position: "absolute",
                    zIndex: 1000,
                  }}
                >
                  {filteredSuggestions.map((item, index) => (
                    <li
                      key={index}
                      className="dropdown-item"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setEmpname(item.employee_name);
                        setEmpnameID(item.employee_id);
                        setShowSuggestions(false);
                      }}
                    >
                      {item.employee_id} - {item.employee_name}
                    </li>
                  ))}
                </ul>
              )}
            </div> */}

            <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
              <div className="d-flex gap-2">
                <Link
                  to="#"
                  className={`btn ${activeTab === "KRA" ? "btn btn-primary custom_button" : "btn btn-primary tab-button"
                    }`}
                  onClick={() => {
                    setKraCallAuto(false);
                    setActiveTab("KRA");
                    getKRAGoals();
                  }}
                >
                  KRA Goals
                </Link>
                <Link
                  to="#"
                  className={`btn ${activeTab === "BEHAI" ? "btn btn-primary custom_button" : "btn btn-primary tab-button"
                    }`}
                  onClick={() => {
                    setKraCallAuto(false);
                    setActiveTab("BEHAI");
                    getBehaviouralGoals();
                  }}
                >
                  Behavioural Goals
                </Link>
              </div>
            </div>

            {/* Table Content */}
            <div className="card-body p-0">
              <Table
                dataSource={
                  activeTab === "KRA"
                    ? getKRAGoalsResponse?.data
                    : getbehaviouralGoalsResponse?.data
                }
                columns={activeTab === "KRA" ? kracolumns : bracolumns}
                Selection={false}
              />
            </div>
          </div>

          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">
            © {new Date().getFullYear()} WeConnect. All rights reserved.
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}

      {/* Add Modal */}
      <div className="modal fade" id="add_category">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title text-capitalize">Assign Goals</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={AddNewItem}>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Employee<span className="text-danger">*</span>
                      </label>
                      <select
                        name="employee_id"
                        value={newItem.employee_id}
                        className="form-select"
                        onChange={getInputdata}
                      >
                        <option value="">Select Employee</option>
                        {data?.map((item: any, index: any) => (
                          <option value={item.employee_id}>
                            {item.employee_id} - {item.employee_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Select Category
                        <span className="text-danger">*</span>
                      </label>
                      <select
                        name="category_id"
                        id=""
                        className="form-select"
                        onChange={getInputdata}
                        value={newItem.category_id}
                      >
                        <option value="">Select Category</option>
                        {getcategoryResponse?.data?.map(
                          (item: any, index: any) => (
                            <option value={item.category_id}>
                              {item.category_name}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-check mb-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="is_eligible_promotion"
                        name="is_eligible_promotion"
                        onChange={getInputdata}
                        checked={newItem.is_eligible_promotion === "Yes"}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="is_eligible_promotion"
                      >
                        Eligible for Promotion
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary custom_button">
                  Assign Goals
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      <div className="modal fade" id="edit_behavCom">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title text-capitalize">
                Edit Behavioural Competency
              </h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={UpdateItemData}>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Employee<span className="text-danger">*</span>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Behavioural Competency
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className={`modal fade ${modalOpen ? "show" : ""}`}
        id="employee_data_modal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden={!modalOpen}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <img
                src="/assets/img/logo/weconnectlogo.png"
                alt=""
                style={{ height: "50px" }}
              />
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setModalOpen(false)}
              />
            </div>
            <div className="modal-body">
              <div className="card-body p-0">
                <Table
                  dataSource={data}
                  columns={employeeColumns}
                  Selection={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Goals;
